import React, { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import Dialog from "src/components/Dialog";
import LoadableButton from "src/components/LoadableButton";
import VendorField from "src/components/VendorField";
import { useRecategorizeDialogStyles } from "./styles";

interface VendorAssignDialogProps {
  open: boolean;
  transactionCount: number;
  onClose: () => void;
  onConfirm: (vendorId?: string) => void;
  loading?: boolean;
}

type ContentProps = Omit<VendorAssignDialogProps, "open">;

function VendorAssignDialogContent({
  transactionCount,
  onClose,
  onConfirm,
  loading = false,
}: ContentProps) {
  const classes = useRecategorizeDialogStyles();
  const [selectedVendorId, setSelectedVendorId] = useState<string | undefined>(
    undefined
  );
  const [touched, setTouched] = useState(false);

  const handleConfirm = () => {
    onConfirm(selectedVendorId);
  };

  const handleChange = (vendorId?: string) => {
    setSelectedVendorId(vendorId);
    setTouched(true);
  };

  return (
    <>
      <DialogTitle>Change Vendor</DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.subtitle}>
          Select a vendor for {transactionCount} transaction
          {transactionCount !== 1 ? "s" : ""}.
        </DialogContentText>
        <VendorField
          value={selectedVendorId}
          onChange={handleChange}
          label="Vendor"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <LoadableButton
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={!touched}
          loading={loading}
        >
          Change Vendor
        </LoadableButton>
      </DialogActions>
    </>
  );
}

function VendorAssignDialog({
  open,
  ...contentProps
}: VendorAssignDialogProps) {
  return (
    <Dialog open={open} onClose={contentProps.onClose} fullWidth maxWidth="xs">
      {open && <VendorAssignDialogContent {...contentProps} />}
    </Dialog>
  );
}

export default VendorAssignDialog;
